export default __webpack_public_path__ + "static/media/1944.d54a44c9.png";